import React, { useState } from "react";
import { Modal, Upload, Button, notification } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import axios from "axios";
import { api } from "../utils/Api";

const QAQCAddComATicketModal = ({
	openComATicketModal,
	setOpenComATicketModal,
	selectedJob,
	setSelectedJob,
	setRefresh,
}) => {
	const [fileList, setFileList] = useState([]);
	const [loading, setLoading] = useState(false);
	const [apiNotification, contextHolder] = notification.useNotification();
	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	const handleUpload = async () => {
		if (fileList.length === 0) {
			openNotification("warning", "Warning", "Please select a file");
			return;
		}

		setLoading(true);

		const formData = new FormData();
		formData.append("file", fileList[0]);

		try {
			const url = api + `/job/add/comaticket/evidence/${selectedJob.id}`;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = {
				Authorization: `Bearer ${token}`,
			};
			const config = {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			};

			const { data } = await axios.post(url, formData, config);
			console.log(data);
			if (data.success) {
				openNotification("success", "Success", data.message);
				setSelectedJob(null);
				setRefresh((prev) => !prev);
				setOpenComATicketModal(false);
			} else {
				openNotification("error", "Error", data.message);
			}
			setFileList([]);
		} catch (error) {
			console.log(error);
			openNotification("error", "Error", "Upload failed");
		} finally {
			setLoading(false);
		}
	};

	return (
		<Modal
			title="Upload PDF File"
			open={openComATicketModal}
			onCancel={() => setOpenComATicketModal(false)}
			onOk={handleUpload}
			okText="Upload"
			confirmLoading={loading} // ✅ this is the key
		>
			<Upload
				beforeUpload={(file) => {
					const isPdf =
						file.type === "application/pdf" ||
						file.name.toLowerCase().endsWith(".pdf");

					if (!isPdf) {
						openNotification(
							"warning",
							"Warning",
							"You can only upload PDF files!",
						);
						return Upload.LIST_IGNORE;
					}

					setFileList([file]);
					return false; // prevent auto upload
				}}
				accept=".pdf,application/pdf"
				fileList={fileList}
				onRemove={() => setFileList([])}
				maxCount={1}
				disabled={loading}
			>
				<Button icon={<UploadOutlined />}>Select PDF File</Button>
			</Upload>
			{contextHolder}
		</Modal>
	);
};

export default QAQCAddComATicketModal;
